import React from 'react';

function PageNotFound(){
    return (
        <div className="page-not-found">
            <h1>404</h1>
            <h2>Oops, page not found!</h2>
            <p>Either something went wrong or the page doesn’t exist.</p>
        </div>
    );
}

export default PageNotFound;